import { jsx } from '@amazon/vinyl-tsx'

const DEFAULT_ROW_COUNT = 8

export interface TrackRowSkeletonProps {
    readonly count?: number
}

/** Stack of shimmering track-row placeholders for vertical track lists while a page of tracks loads. */
export function TrackRowSkeleton(props?: TrackRowSkeletonProps | null) {
    const count = props?.count ?? DEFAULT_ROW_COUNT
    return (
        <div className="trackRowSkeleton" aria-hidden="true">
            {...Array.from({ length: count }, () => <div className="trackRowSkeletonRow" />)}
        </div>
    )
}
